export default __webpack_public_path__ + "static/media/gimp.47e651ab.svg";